import {
  aSignalPage,
  mockRuleBuilderLastSignalQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const ruleBuilderLastSignalResponse = {
  __typename: 'Query' as const,
  signals: aSignalPage(),
};

export const handlers = [
  mockRuleBuilderLastSignalQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: ruleBuilderLastSignalResponse,
      });
    }
  ),
];
